import PropTypes from 'prop-types'
import cx from 'classnames'

import ModalFrame from 'common/components/ModalFrame'

import styles from './ResetDeviceModal.module.scss'

const ResetDeviceModal = ({ deviceName, hideModal, isCancelReset, onConfirm }) => {
  const actionLabel = isCancelReset ? 'CANCELAR RESET' : 'RESETEAR'
  const message = isCancelReset
    ? `¿Estás seguro de que quieres cancelar el reset del dispositivo ${deviceName}?`
    : `¿Estás seguro de que quieres resetear el dispositivo ${deviceName}?`

  const handleConfirm = () => {
    hideModal()
    onConfirm()
  }

  return (
    <ModalFrame
      className={styles.modal}
      hideModal={hideModal}
      scrollable
    >
      <h2 className={styles.title}>Aviso</h2>
      <p className={styles.message}>{message}</p>
      {isCancelReset && (
        <p className={styles.note}>
          Si el dispositivo ya la ha procesado, puede que no sea posible detenerla.
        </p>
      )}
      <div className={styles.actions}>
        <button
          className={styles.cancelButton}
          onClick={hideModal}
          type='button'
        >
          CANCELAR
        </button>
        <button
          className={cx(styles.confirmButton, isCancelReset && styles.cancelResetButton)}
          onClick={handleConfirm}
          type='button'
        >
          {actionLabel}
        </button>
      </div>
    </ModalFrame>
  )
}

ResetDeviceModal.propTypes = {
  deviceName: PropTypes.string.isRequired,
  hideModal: PropTypes.func.isRequired,
  isCancelReset: PropTypes.bool.isRequired,
  onConfirm: PropTypes.func.isRequired
}

export default ResetDeviceModal
